var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',[_c('template',{slot:"start"},[_c('b-navbar-item',{attrs:{"tag":"router-link","to":{ path: '/' }}},[_vm._v("Home")])],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }